import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { I18nProvider } from "@/i18n/I18nContext";
import Home from "@/pages/Home";
import AugustLanding from "@/pages/AugustLanding";
import SpringLanding from "@/pages/SpringLanding";
import ShoulderLanding from "@/pages/ShoulderLanding";
import Booking from "@/pages/Booking";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ReviewPage from "@/pages/ReviewPage";
import GuestPortal from "@/pages/GuestPortal";
import StickyReserve from "@/components/StickyReserve";
import MetaPixelListener from "@/components/MetaPixelListener";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <MetaPixelListener />
          <Toaster position="top-center" richColors closeButton />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/august" element={<AugustLanding />} />
            <Route path="/spring" element={<SpringLanding />} />
            <Route path="/shoulder" element={<ShoulderLanding />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/review/:token" element={<ReviewPage />} />
            <Route path="/guests" element={<GuestPortal />} />
          </Routes>
          <StickyReserve />
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
